import axios from 'axios'
// import Vue from 'vue'
// import vue from '../main'
import router from '@/router'
import { Toast } from 'vant'

var urllink = 'http://gateway2.fst1994.net' // 线上
//var urllink = 'http://114.107.229.59:21020' // 接口地址
//var urllink = 'http://192.168.31.80:21020' // 接口地址
// var urllink = 'http://192.168.1.178:21020'//接口地址
// const Userinfo = window.localStorage.userinfo ? JSON.parse(window.localStorage.userinfo):'' //用户信息有token ，refreshToken，expireTime
// create an axios instance
const service = axios.create({
  baseURL: urllink,
  timeout: 10000 // request timeout
})
// request interceptor
service.interceptors.request.use(
  config => {
    // do something before request is se nt
    var timestamp = new Date().getTime()
    const Userinfo = window.localStorage.userinfo ? JSON.parse(window.localStorage.userinfo) : '' //用户信息有token ，refreshToken，expireTime
    var expireTime = Userinfo.expireTime
    if (Userinfo.token) {
      if (timestamp > expireTime) {
        config.headers['Authorization'] = Userinfo.refreshToken
        config.headers['X-Token'] = Userinfo.refreshToken
      } else {
        config.headers['Authorization'] = Userinfo.token
        config.headers['X-Token'] = Userinfo.token
      }
    }
    config.headers['Content-Type'] = 'application/json'
    return config
  },
  error => {
    return Promise.reject(error)
  }
)
// response interceptor
service.interceptors.response.use(
  response => {
    const code = response.status
    if (code < 200 || code > 300) {
      Toast.fail(response.message);
      return Promise.reject('error')
    } else {
      return response.data
    }
  },
  error => {
    let code = 0
    try {
      code = error.response.status
    } catch (e) {
      if (error.toString().indexOf('Error: timeout') !== -1) {
        Toast.fail("网络请求超时");
        return Promise.reject(error)
      }
    }
    if (code) {
      if (code === 403) {
        // Toast.fail("登录状态已过期，您可以继续留在该页面，或者重新登录");
        // vue.login();
      } else if (code === 401) {
        router.push({ path: '/401' })
      } else {
        const errorMsg = error.response.data.message
        if (errorMsg !== undefined) {
          Toast.fail(errorMsg);
        }
      }
    } else {
      Toast.fail("接口请求失败");
    }
    return Promise.reject(error)
  }
)

export default service
